export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  views: number;
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '某顶流男星被曝深夜密会神秘女子，酒店同框照流出引猜测',
    excerpt: '近日有网友爆料称，某顶级流量男星在深夜被拍到与一名神秘女子一同进入某五星级酒店，两人举止亲密。照片已在社交平台广泛传播，引发网友热议。',
    content: `<p>近日，有网友在社交平台发布了一组照片，照片中显示某顶级流量男星在深夜时分与一名神秘女子一同出现在某五星级酒店大堂。据拍摄者描述，两人进入酒店后直至次日清晨才分别离开，期间并未有其他人员同行。</p>
    <p>该网友表示，自己当时也在该酒店入住，碰巧目睹了全过程。照片中该男星身穿黑色卫衣戴着口罩和帽子，但从身形和走路姿态来看，与其公开活动中的形象高度吻合。</p>
    <h2>粉丝反应两极分化</h2>
    <p>消息一出，粉丝群体立即炸开了锅。一部分粉丝表示"艺人也需要私人空间"，认为偷拍行为侵犯隐私；另一部分粉丝则表达了失望情绪，要求工作室给出明确回应。</p>
    <p>"作为公众人物就应该注意自己的行为，这样偷偷摸摸算什么？"一位脱粉的网友在评论区写道。</p>
    <h2>工作室保持沉默</h2>
    <p>截至目前，该男星的工作室和经纪公司均未对此事做出任何回应，这种沉默态度反而让事件持续发酵。多家娱乐媒体已跟进报道，相关话题阅读量已突破3亿。</p>
    <h2>业内人士分析</h2>
    <p>有资深娱乐记者分析认为，如果照片属实，这将对这位男星的商业价值产生不小的影响。"他现在手里有多个一线品牌的代言合同，其中包含形象维护条款，如果被证实是不当行为，可能面临高额违约金。"</p>
    <p>事件仍在持续发展中，黑料bu将持续关注并为您带来最新进展。</p>`,
    category: 'mingxing',
    author: '黑料bu编辑部',
    date: '2026-08-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20walking%20at%20night%20in%20luxury%20hotel%20lobby%2C%20wearing%20black%20hoodie%20and%20mask%2C%20paparazzi%20style%20blurry%20photography%2C%20dramatic%20lighting%2C%20cinematic%20noir%20aesthetic%2C%20warm%20amber%20and%20dark%20tones&width=800&height=450&seq=article-01&orientation=landscape',
    tags: ['顶流', '男星', '酒店', '绯闻'],
    views: 128500,
    isHot: true,
  },
  {
    id: 2,
    title: '千万粉丝网红直播时意外翻车，真实颜值曝光粉丝直呼上当',
    excerpt: '某拥有千万粉丝的网红主播在一次直播中出现技术故障，美颜滤镜突然失效，真实面容与平时发布的精修照片差距巨大，引发大量粉丝脱粉。',
    content: `<p>昨晚，一位在短视频平台拥有超过1200万粉丝的知名网红在直播过程中遭遇了"灾难性"的技术故障——她的直播美颜滤镜突然失效了近30秒。就是这短短30秒，让她的真实面容完全暴露在了观众面前。</p>
    <p>据观看直播的网友描述，该网红在失去美颜效果后，皮肤状态、五官比例与平时发布的精修照片和短视频内容存在明显差异。许多粉丝当场表示"认不出来了"。</p>
    <h2>直播间弹幕炸裂</h2>
    <p>事故发生后，直播间弹幕瞬间沸腾。"这是同一个人吗？""我的天哪我被骗了两年""取关了取关了"等评论刷屏。直播间的在线人数从事故前的8万多人飙升到了15万，但关注数却开始断崖式下跌。</p>
    <h2>事后回应引发更大争议</h2>
    <p>事件发酵后，该网红在个人社交账号上发表声明称"每个人都有不完美的一面"，并表示美颜只是"提升直播效果的工具"。但这番回应被许多网友认为是避重就轻。</p>
    <p>"问题不是美颜，而是你和精修图的差距大到让人感觉是两个人，这属于欺骗。"一位网友的评论获得了超过10万点赞。</p>
    <h2>行业乱象再次被讨论</h2>
    <p>此事也让"网红真实颜值"话题再次登上热搜。不少业内人士指出，过度依赖美颜和修图已经成为行业的普遍现象，亟需规范和自律。</p>`,
    category: 'wanghong',
    author: '黑料bu编辑部',
    date: '2026-08-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20in%20a%20dark%20room%20with%20ring%20light%2C%20surprised%20expression%2C%20camera%20glitch%20effect%2C%20dramatic%20contrast%20between%20filtered%20and%20unfiltered%20look%2C%20noir%20cinematic%20style%2C%20warm%20tone&width=800&height=450&seq=article-02&orientation=landscape',
    tags: ['网红', '直播翻车', '美颜', '脱粉'],
    views: 96500,
    isHot: true,
  },
  {
    id: 3,
    title: '知名女星被曝偷税漏税数千万，税务局已介入调查',
    excerpt: '据知情人士透露，某知名一线女星因涉嫌偷逃税款被税务部门立案调查，涉及金额高达数千万元。该女星此前一直以"正能量"形象示人。',
    content: `<p>据可靠消息源透露，国家税务总局已对某知名一线女星涉嫌偷逃税案件正式立案调查。据初步核查，该女星在2019年至2024年间，通过多种手段涉嫌偷逃个人所得税及增值税，涉案金额可能高达数千万元。</p>
    <p>业内人士透露，该女星近年来商业活动频繁，代言、影视剧片酬、综艺出场费等收入均属于行业顶尖水平，但其纳税记录与收入状况存在明显不匹配。</p>
    <h2>税务部门表态：严查不贷</h2>
    <p>税务部门相关负责人在接受采访时表示，对于高收入人群的税务问题，始终坚持依法查处、绝不姑息的态度。目前案件正在进一步调查中，具体细节暂不便透露。</p>
    <h2>品牌方紧急切割</h2>
    <p>消息传出后，与该女星有合作关系的多个品牌已紧急启动危机公关预案。据悉，已有至少三个一线品牌暂停了与该女星的广告投放计划，部分品牌甚至考虑提前终止合约。</p>
    <h2>前车之鉴历历在目</h2>
    <p>娱乐圈税务问题并非首次被曝光。此前多位明星因税务问题被处以巨额罚款甚至面临刑事处罚。此次事件再次敲响了警钟。</p>
    <p>黑料bu将持续关注案件进展，为您带来最新报道。</p>`,
    category: 'mingxing',
    author: '黑料bu编辑部',
    date: '2026-08-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20tax%20investigation%20scene%2C%20documents%20and%20calculator%20on%20dark%20wooden%20desk%2C%20dramatic%20lighting%20from%20window%2C%20serious%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20shadow%20tones&width=800&height=450&seq=article-03&orientation=landscape',
    tags: ['女星', '偷税', '税务调查', '代言'],
    views: 213000,
    isHot: true,
  },
  {
    id: 4,
    title: 'B站百万UP主被扒抄袭海外博主，视频内容高度雷同长达两年',
    excerpt: 'B站一位拥有超过200万粉丝的知名UP主被网友实锤长期抄袭海外YouTube博主的内容，从选题、分镜到文案几乎一字不差地"汉化"搬运。',
    content: `<p>近日，B站一位拥有超过200万粉丝的知名UP主陷入了严重的抄袭风波。有网友通过逐帧对比发现，该UP主近两年来的多个视频作品与海外YouTube博主的视频内容高度雷同，从选题方向、分镜设计到文案表述都存在大量"巧合"。</p>
    <p>爆料网友制作了详细的对比视频，将两个频道的作品并排展示，相似度之高令人咋舌——不仅讲解逻辑完全一致，连玩笑话和转折点出现的时间节点都惊人地吻合。</p>
    <h2>UP主回应：只是"参考灵感"</h2>
    <p>面对越来越多的质疑声，该UP主于昨晚发布了一条回应视频，声称自己的作品只是"参考了优秀创作者的灵感"，并非抄袭，并指责对比视频"断章取义"。</p>
    <p>然而这番解释并未获得网友认可。有法律专业人士指出，如果对比视频属实，这种行为在法律层面可能构成著作权侵权。</p>
    <h2>平台态度引关注</h2>
    <p>截至目前，B站官方尚未对此事做出公开回应。不少用户呼吁平台应该建立更严格的内容审核机制，保护原创作者的权益。该事件也让"内容汉化"这一灰色地带再次成为讨论焦点。</p>`,
    category: 'dawei',
    author: '黑料bu编辑部',
    date: '2026-08-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20video%20editing%20screens%20side%20by%20side%20showing%20identical%20content%2C%20dark%20room%20with%20monitor%20glow%2C%20plagiarism%20comparison%20concept%2C%20cinematic%20noir%20style%2C%20warm%20orange%20and%20shadow%20tones&width=800&height=450&seq=article-04&orientation=landscape',
    tags: ['B站', 'UP主', '抄袭', 'YouTube'],
    views: 87500,
    isHot: false,
  },
  {
    id: 5,
    title: '娱乐圈模范夫妻被曝已分居半年，第三者身份疑似曝光',
    excerpt: '一直被外界称为"娱乐圈模范夫妻"的两位知名演员，被曝已秘密分居半年之久。更有消息称，疑似有第三者介入导致婚姻破裂。',
    content: `<p>曾被粉丝誉为"娱乐圈最后的神仙眷侣"的一对知名演员夫妇，近日被媒体曝出婚姻出现严重危机。据知情人士透露，两人已经分居超过半年，只是因为商业利益和子女问题迟迟没有公开。</p>
    <p>更引人关注的是，有媒体拍到男方近期多次与一位圈外女性同进同出，两人关系似乎不一般。该女性的身份已被部分网友扒出，据称是某投资公司高管。</p>
    <h2>社交平台互动归零</h2>
    <p>细心的粉丝发现，两人在社交平台上的互动已经停滞了将近一年。以前频繁的甜蜜互动、节日祝福全部消失，甚至连对方的生日都没有公开祝福。</p>
    <h2>商业捆绑成阻碍</h2>
    <p>据业内人士分析，两人之所以迟迟不公开离婚消息，与他们共同持有的多个商业项目和代言合同有关。"他们夫妻档的商业价值远高于单打独斗，一旦公开离婚，多个品牌合作可能面临解约风险。"</p>
    <h2>粉丝心碎</h2>
    <p>消息传出后，不少粉丝表示难以接受。"他们可是我磕了十年的CP啊""再也不相信爱情了"等感慨刷屏社交平台。</p>`,
    category: 'mingxing',
    author: '黑料bu编辑部',
    date: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cracked%20wedding%20photo%20frame%20on%20a%20dark%20table%2C%20dramatic%20lighting%2C%20sad%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20emotional%20concept&width=800&height=450&seq=article-05&orientation=landscape',
    tags: ['模范夫妻', '分居', '第三者', '婚姻'],
    views: 156000,
    isHot: true,
  },
  {
    id: 6,
    title: '带货主播涉嫌虚假宣传被罚500万，曾创下单场破亿销售记录',
    excerpt: '某头部带货主播因在直播中虚假宣传产品功效，被市场监管部门处以500万元罚款。该主播此前一直以"良心带货"人设著称。',
    content: `<p>近日，市场监督管理部门对某头部直播带货主播做出了500万元的行政处罚决定，原因是该主播在多次直播中对所售产品的功效进行了夸大和虚假宣传。</p>
    <p>据了解，该主播在推广某品牌保健品时，声称产品具有"抗癌""抗衰老"等未经科学证实的功效，并使用"绝对有效""百分百好评"等绝对化用语，违反了广告法和反不正当竞争法的相关规定。</p>
    <h2>消费者投诉成导火索</h2>
    <p>此次处罚的导火索是大量消费者的集中投诉。不少购买了该产品的消费者表示，实际使用效果与直播中宣传的相差甚远，甚至有人出现了不良反应。</p>
    <h2>行业整顿信号</h2>
    <p>业内人士认为，此次处罚释放了监管部门加强对直播带货行业规范的信号。"直播带货野蛮生长的时代已经过去了，合规经营是未来的主旋律。"</p>
    <h2>主播道歉但不服</h2>
    <p>处罚公布后，该主播在直播间公开道歉，但同时暗示自己被"竞争对手恶意举报"，表示将申请行政复议。这番态度再次引发网友不满。</p>`,
    category: 'wanghong',
    author: '黑料bu编辑部',
    date: '2026-08-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20live%20streaming%20seller%20in%20a%20studio%20with%20products%20on%20table%2C%20dramatic%20red%20warning%20stamp%20overlay%2C%20dark%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20crimson%20tones&width=800&height=450&seq=article-06&orientation=landscape',
    tags: ['带货', '虚假宣传', '罚款', '直播'],
    views: 74500,
    isHot: false,
  },
  {
    id: 7,
    title: '知名导演被多名女演员举报潜规则，聊天记录截图在网络流传',
    excerpt: '多位女演员联合举报某知名导演在剧组期间利用职务之便进行不当行为，部分聊天记录截图已在网络流传，引发娱乐圈震动。',
    content: `<p>一场席卷娱乐圈的风暴正在酝酿。近日，多位女演员通过社交媒体联合发声，实名或匿名举报某知名导演在多个剧组的工作期间存在不当行为，包括言语骚扰、要求单独"试戏"等。</p>
    <p>据其中一位举报者描述，该导演在拍摄期间经常以"讨论剧本"为由，在深夜单独约见年轻女演员，并在交流中多次出现越界行为。部分聊天记录截图已在网络上广泛传播。</p>
    <h2>行业协会紧急发声</h2>
    <p>事件发酵后，中国电影导演协会发表声明，表示将密切关注此事进展，呼吁业内人士遵守职业道德，并承诺配合相关部门进行调查。</p>
    <h2>涉事导演暂未回应</h2>
    <p>截至目前，被举报的导演本人及工作室均未做出任何公开回应。其个人社交账号评论区已被大量网友涌入，要求其正面回应指控。</p>
    <h2>行业风气再受审视</h2>
    <p>此事再次将娱乐圈的潜规则问题推到了聚光灯下。多位业内人士呼吁建立更完善的举报和保护机制，让从业者能够在安全的环境中工作。</p>`,
    category: 'mingxing',
    author: '黑料bu编辑部',
    date: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20film%20director%20chair%20on%20a%20dark%20movie%20set%2C%20dramatic%20single%20spotlight%2C%20shadowy%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20deep%20black%20tones&width=800&height=450&seq=article-07&orientation=landscape',
    tags: ['导演', '潜规则', '举报', '女演员'],
    views: 189000,
    isHot: true,
  },
  {
    id: 8,
    title: '微博大V被曝买粉造假，百万粉丝账号实际活跃用户不足千人',
    excerpt: '一位微博粉丝数超过300万的知名大V被技术手段扒出，其账号的真实活跃粉丝可能不足1000人，其余均为购买的僵尸粉。',
    content: `<p>微博粉丝经济的遮羞布正在被一层层揭开。近日，有技术博主通过数据分析工具对一位粉丝数超过300万的知名微博大V进行了深入分析，结果令人震惊——该账号的真实活跃粉丝可能不足1000人。</p>
    <p>根据分析报告，该大V发布的微博平均转发量虽然高达数千，但大部分转发的账号都是没有头像、没有原创内容、注册时间集中的僵尸号。而真正产生有效互动的用户少得可怜。</p>
    <h2>广告主被坑惨</h2>
    <p>这一发现让许多曾与该大V合作的品牌方欲哭无泪。据悉，该大V单条广告报价高达数万元，品牌方本以为可以触达百万真实用户，结果却投放给了一群"机器人"。</p>
    <h2>平台数据造假成顽疾</h2>
    <p>业内人士指出，社交媒体平台上的数据造假问题由来已久，从买粉、买转、买赞到买评论，已经形成了一条完整的灰色产业链。虽然平台方面多次表态要打击，但效果有限。</p>
    <h2>如何辨别真假大V？</h2>
    <p>有经验的营销人士建议，品牌方在选择合作对象时，不应只看粉丝数量，而应更关注互动率、粉丝增长曲线的合理性以及评论内容的质量等指标。</p>`,
    category: 'dawei',
    author: '黑料bu编辑部',
    date: '2026-07-31',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fake%20social%20media%20followers%20concept%2C%20robot%20silhouettes%20behind%20a%20phone%20screen%2C%20dark%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20orange%20glow%20against%20deep%20shadows&width=800&height=450&seq=article-08&orientation=landscape',
    tags: ['大V', '买粉', '造假', '微博'],
    views: 63500,
    isHot: false,
  },
  {
    id: 9,
    title: '某选秀冠军被曝与经纪人合伙诈骗粉丝，涉案金额或超千万',
    excerpt: '一位选秀节目出身的冠军选手被多位粉丝联合举报，指控其与经纪人合谋以"投资理财"为名骗取粉丝钱财，受害者遍布全国。',
    content: `<p>一场令人震惊的粉丝诈骗案正在浮出水面。多位粉丝联合向公安机关报案，指控某选秀节目的冠军选手及其经纪人以"内部投资机会"为名，骗取粉丝钱财，涉案金额预计超过千万元。</p>
    <p>据受害者描述，该艺人通过粉丝群私下联系部分"铁粉"，声称有一个"稳赚不赔"的内部投资机会，因为是"自家人"才分享。在初期，部分参与者确实收到了小额回报，这让他们放松了警惕并加大了投入。</p>
    <h2>庞氏骗局特征明显</h2>
    <p>金融专家分析指出，该案件具有典型的庞氏骗局特征——用后来者的资金支付先行者的回报，一旦资金链断裂，所有参与者都会血本无归。</p>
    <h2>警方已立案</h2>
    <p>目前，多地警方已接到相关报案，部分地区的公安机关已经正式立案。据悉，该艺人及其经纪人已被限制出境。</p>
    <h2>粉丝经济再敲警钟</h2>
    <p>此事件也引发了对粉丝经济模式的深层反思。当偶像与粉丝之间的关系被金钱过度捆绑时，这种不对等的关系极易滋生利用和欺骗。</p>`,
    category: 'mingxing',
    author: '黑料bu编辑部',
    date: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20piggy%20bank%20with%20money%20scattered%20on%20dark%20surface%2C%20handcuffs%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20crimson%20tones&width=800&height=450&seq=article-09&orientation=landscape',
    tags: ['选秀', '诈骗', '粉丝', '报案'],
    views: 142000,
    isHot: true,
  },
  {
    id: 10,
    title: '知名美食博主被曝光后厨卫生堪忧，老鼠乱窜画面触目惊心',
    excerpt: '一位以"精致美食"著称的短视频博主，被前员工曝光其拍摄场地的真实卫生状况——后厨老鼠横行、食材过期、环境脏乱不堪。',
    content: `<p>精致美食视频背后的真相让人大跌眼镜。一位在短视频平台上拥有800多万粉丝的知名美食博主，近日被一位自称是其前助理的员工实名爆料，揭露了其视频拍摄背后的卫生乱象。</p>
    <p>该前员工提供了一段用手机拍摄的视频，画面中可以看到厨房内老鼠在地面和操作台上肆意活动，部分食材已经明显变质发霉，但仍在被用于视频拍摄。这段视频在网络上迅速传播，观看量已突破千万。</p>
    <h2>博主紧急下架视频</h2>
    <p>事件曝光后，该博主紧急下架了多个近期发布的视频，并关闭了评论区。但其沉默态度反而激起了网友更大的愤怒。</p>
    <h2>食品安全引关注</h2>
    <p>市场监管部门已关注到此事，表示将对涉事博主的经营场所进行检查。食品安全专家提醒，网络美食视频中展示的"精致"往往只是表象，消费者需保持理性。</p>
    <h2>行业乱象曝光</h2>
    <p>此事也让更多人开始关注美食自媒体行业的卫生问题。据了解，许多美食博主使用的是临时搭建的拍摄场地，根本不具备食品加工所需的卫生条件。</p>`,
    category: 'wanghong',
    author: '黑料bu编辑部',
    date: '2026-07-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20kitchen%20with%20dim%20lighting%2C%20messy%20countertops%2C%20contrast%20between%20beautiful%20food%20photography%20and%20filthy%20reality%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20dark%20shadow%20tones&width=800&height=450&seq=article-10&orientation=landscape',
    tags: ['美食博主', '卫生', '曝光', '食品安全'],
    views: 112000,
    isHot: false,
  },
];